import React from "react";
import "./UaeMofa.css";
import UaeMofaHead from "./UaeMofaHead";
import UaeMofaMain from "./UaeMofaMain";
const UaeMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <UaeMofaMain />
    </div>
  );
};

export default UaeMofa;
